import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderDetailsComplex from "./order-cargo-order-details-complex";
import OrderCargoOrderDetailsComplexParams from "./order-cargo-order-details-complex-params";

const useOrderCargoOrderDetailsComplex = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderCargoOrderDetailsComplex | null>(null);

  const load = async (
    params: OrderCargoOrderDetailsComplexParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderDetails = await orderService.getDetailsComplex(
        params,
        signal,
      );

      setData(cargoOrderDetails);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useOrderCargoOrderDetailsComplex;
